import React from "react";
// Custom  Input

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";

// Types
interface CustomInputProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  name?: string;
  multiline?: boolean;
  rows?: number;
  required?: boolean;
  onBlur?: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  name,
  multiline = false,
  rows = 5,
  required = false,
  onBlur,
  disabled,
  sx,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        zIndex: 12,
      }}
    >
      <Typography variant="body1" mb={"10px"}>
        {label} {required && <Typography component="span">*</Typography>}
      </Typography>

      <TextField
        fullWidth
        placeholder={placeholder}
        value={value}
        multiline={multiline}
        disabled={disabled}
        rows={rows}
        onChange={onChange}
        id={name}
        type={type}
        name={name}
        required={required}
        onBlur={onBlur}
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            background: disabled ? "#F4F5FA" : "#fcfcfc",
            "& fieldset": {
              border: "1px solid #c3c3c3",
            },
            "&:hover fieldset": {
              border: "2px solid #1976d2",
            },
            "&.Mui-focused fieldset": {
              border: "2px solid #1976d2",
            },
            "& input": {
              padding: "6px 10px",
              color: "#181B25",
              fontWeight: 400,
              fontSize: 15,
              minHeight: 24,
              fontFamily: "Figtree",
              "&::placeholder": {
                color: "#B0B0B0",
                opacity: 1,
              },
            },
            ...(sx as any),
          },
        }}
      />
    </Box>
  );
};

export default CustomInput;
